import React, { useEffect, useState } from 'react';
import {
 Chart as ChartJS,
 CategoryScale,
 LinearScale,
 BarElement,
 PointElement,
 LineElement,
 Title,
 Tooltip,
 Legend
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Bar, Chart } from "react-chartjs-2";
import useAxios from 'hooks/useAxios';
ChartJS.register(
 CategoryScale,
 LinearScale,
 BarElement,
 PointElement,
 LineElement,
 Title,
 Tooltip,
 Legend,
 ChartDataLabels
);
import {
    Card,
    CardBody,
    CardTitle,
    Col,
    Row,
    CardHeader,
    Button,
    Nav,
    NavItem,
    NavLink,
} from 'reactstrap';
import ErrorBoundary from 'components/ErrorBoundary';
import Drawer from 'components/Drawer';
import RetailvsMailOrderUtilizationDrawer from '../GridData/RetailvsMailOrderUtilizationDrawer';
import { default as ReactSelect } from "react-select";
const RetailvsMailOrderUtilization  = ({data,searchData}) => {
  const API = useAxios();
   const {dateRange, pbmPlanId, pbmGroupID,planCode, startDate, endDate} = searchData;
     const [isOpen, setIsOpen] = useState(false);
      const [disabledViewButtom, setDisabledViewButtom] = useState(true);
    const [graphClaimStatus,setGraphClaimStatus] = useState('NPC');
    searchData.graphClaimStatus=graphClaimStatus;
     const[retailMailData,setRetailMailData]=useState(data);
     const [disabledChartFilterButton, setDisabledChartFilterButton] = useState(true);
     const retailvsMailOrderData=[];
       const claimStatus = [
        { value: 'ALL', label: 'All' },
        { value: 'NPC', label: 'Net Paid Claims' },
        { value: 'REJ', label: 'Rejected' },
        { value: 'REV', label: 'Reversal' }
    ]
    useEffect(()=>{
    if(pbmPlanId==-1){
        setGraphClaimStatus("NPC")
    }
    },[pbmPlanId])
   const handleStatus = (value) => {
       const datavalue= []
        setGraphClaimStatus(value.value)
        getRetailvsMailOrderUtilization(value.value)
    }
  useEffect(() => {
    if (data != null && (data[0]?.labels?.length > 0 || data[0]?.retailCount?.length > 0 || data[0]?.mailorderCount?.length > 0)) {
      setRetailMailData(data)
      setDisabledViewButtom(false);
      setDisabledChartFilterButton(false);
    } else {
      setDisabledViewButtom(true);
      setRetailMailData([]);
      setGraphClaimStatus('NPC');
      setDisabledChartFilterButton(true);
    }
  }, [data]);

       const getRetailvsMailOrderUtilization=async(graphClaimStatus)=>{
        const  data1  = await API.get(
            `/PBMTenant/${pbmPlanId}/PBMClientDashboard/getRetailvsMailOrderUtilization/${pbmGroupID}/${dateRange}/${startDate}/${endDate}/${graphClaimStatus}`);
         retailvsMailOrderData.push(data1.data)
         setRetailMailData(retailvsMailOrderData);
            if (Object.values(data1.data).every(value => value === null)){
             setDisabledViewButtom(true);
          }
          else
          {
            setDisabledViewButtom(false);
          }
        console.log(retailMailData);
      }
     
  const chartData = {

labels:retailMailData[0]?.labels, 
   datasets: [
     {
       type: 'bar',
       label: 'Retail',
       data:retailMailData[0]?.retailCount, 
       backgroundColor: '#B54DA0', // Purple color
       borderColor: '#B54DA0',
       borderWidth: 1,

     },
     {
       type: 'bar',
       label: 'Mail Order',
       data: retailMailData[0]?.mailorderCount,
       backgroundColor: "#702C62",
       borderColor:  "#702C62",
       borderWidth: 1,
     },
   ],
 };

 const options = {
   responsive: true,
   plugins: {
     legend: {
       position: 'bottom',
           labels: {
                        padding: 15,
                        usePointStyle: true,
                        pointStyle: 'rect',
                        color: '#707070',
                        font: {
                            weight: 'bold',
                        },
                    },
                      align: 'start',
     },
     title: {
       display: true,
       text: 'Retail vs Mail Order Utilization',
     },
  datalabels:{
    display:false,
     },
       tooltip: {
        mode: 'index',
        intersect: false,
      
    //         anchor:'start',
    //  align:'end'

  },
     formatter:(value,context)=>{
        if(context.dataset.type=='bar'){
            return value;
        }
        return null
     },
    //  anchor:'start',
    //  align:'end',
   },
   scales: {
    x:{
        stacked:true
    },
     y: {
       beginAtZero: true,
       stacked:false,
     },
   },
 };

 const handleActive = (title) => {
        setActive(title);
    };
    const getDate = () => {
        setActive('custom')
    }
    const handleProceed = () => {
        setIsOpen(!isOpen);
    }
    const onHandleIsOpen = (hasRefresh) => {
        if (isBoolean(hasRefresh) && hasRefresh) {
            onClose(true);
        }
        setIsOpen(!isOpen)
    }
 return (
    <div>
      <ErrorBoundary>
           <Card className='p-3 h-100'>
                            <CardHeader className='border-0 bg-white px-0 pt-0'>
                              <Row className="align-items-center">
                               <Col>
                                <CardTitle className="f-20 font-weight-500">Retail vs Mail Order Utilization</CardTitle>
                               </Col>
                               </Row>
                                 </CardHeader>
              
             <CardBody className='dashboard-chart-body'>
          
              <Bar  data={chartData} options={options} />
                   <div className="view-report">
                                     <Button
                                         color='primary'
                                         className='ms-2'
                                         onClick={handleProceed}
                                         style={{ float: "right", position: "absolute", bottom: "3px", right: "30px"}}
                                         disabled={disabledViewButtom}
                                     >
                                         View Report
                                     </Button>
                                     </div>
                                       <ReactSelect 
                                options={claimStatus}
                                onChange={(e) => handleStatus(e)}
                                value={
                                    claimStatus.filter(option =>
                                        option.value === graphClaimStatus)
                                }
                                className='col-4 mt-4'
                                 isDisabled={disabledChartFilterButton}
                            />
            </CardBody>
            
          </Card>
           <Drawer
                direction='end'
                title='Retail vs Mail Order Utilization'
                isOpen={isOpen}
                toggle={handleProceed}
                size="lg"
            >
                <RetailvsMailOrderUtilizationDrawer searchData={searchData}  onHandleIsOpen={onHandleIsOpen} graphClaimStatus={graphClaimStatus} />
            </Drawer> 
          </ErrorBoundary>
    </div>
 )
}
export default  RetailvsMailOrderUtilization;